import { render, staticRenderFns } from "./SupplierRawMaterialProductAuthenticity.vue?vue&type=template&id=0ad2abd3&scoped=true"
import script from "./SupplierRawMaterialProductAuthenticity.vue?vue&type=script&lang=js"
export * from "./SupplierRawMaterialProductAuthenticity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad2abd3",
  null
  
)

export default component.exports